import { parseAsBoolean } from 'nuqs'

export const EncounterWorkBlockHistoryQueryMap = {
  work_block_history: parseAsBoolean.withDefault(false),
}
